import React, { useEffect, useRef, useState } from 'react';
import M_PER_BASIC_02 from './M_PER_BASIC_02';
import { useLocation, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import Commons from '../../../../Services/Common/Common';
import Global from '../../../../Services/Common/Global';
import { showSnackbar } from '../../../../Reducer/SnackbarReducer';
import { BaseInfoActions } from '../../../../Reducer/BaseInfoReducer';
import useFcmHandler from '../../../../Hooks/useFcmHandler';
import { CommonActions } from '../../../../Reducer/CommonReducer';
import { NavBarInfoActions } from '../../../../Reducer/NavBarInfoReducer';
import { BottomSheetActions } from '../../../../Reducer/BottomSheetReducer';
import { useAppNavigate } from '../../../../Hooks/back/useAppNavigate';
import { useBackStack } from '../../../../Hooks/back/useBackStack';

// 작업허가서 상세 조회 페이지 (반려, 승인 동작)
export default function M_PER_BASIC_02F() {
  const { userInfo } = useSelector((state) => state.BaseInfo);
  const bottomSheetState = useSelector((state) => state.bottomSheet);
  const activeStep = useSelector((state) => state.common.activeStep);
  const dispatch = useDispatch();
  const { id } = useParams();
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const [rowData1, setRowData1] = useState([]); //기본 정보
  const [rowData2, setRowData2] = useState([]); // 체크리스트
  const { navigate } = useAppNavigate();
  const signatureCanvas = useRef();
  const sendFcm = useFcmHandler();
  // UI 상태 관리 (상위로 이동)
  const [activeIndex, setActiveIndex] = useState(0); // 탭 이동 상태
  const [isBaseChecked, setIsBaseChecked] = useState(false); // 기본 작성 정보 체크
  const [isChecklistChecked, setIsChecklistChecked] = useState(false); // 작업별 사전체크 항목 체크
  const [isComplete, setIsComplete] = useState(false);
  const [mode, setMode] = useState();
  const backTo = location.state?.from || '/M_Permit';

  // 스택형 뒤로가기로 변경: 상세에서 목록으로 복귀
  useBackStack({
    type: 'navigate',
    onBack: () => navigate(backTo, { replace: true }),
  });
  const ToggleDrawer = (anchor, open) => () => {
    dispatch(
      BottomSheetActions.SetBottomSheetState({
        bottom: open,
        type: bottomSheetState?.type,
      })
    );
  };

  useEffect(() => {
    SearchLogic1();
  }, [userInfo]);

  // 화면 타이틀/타입 설정 (상위에서 관리)
  useEffect(() => {
    dispatch(NavBarInfoActions.setType('titleBar'));
    dispatch(NavBarInfoActions.setTitleName('작업 허가서'));
  }, [dispatch]);

  const Init = async () => {
    dispatch(CommonActions.setActiveStep(0));
  };

  useEffect(() => {
    Init();
  }, [dispatch]);

  // 작업허가서 FCM (gubun : 2 : 안전관리자가 서명 후 알람, 1 : 결재승인자이 서명 후 알람)
  const handleSignRequest = async (gubun) => {
    dispatch(BaseInfoActions.setFcmReceptionPayload('')); // fcmReceptionPayload 초기화
    //안전관리자에게 알림
    if (gubun === '1') {
      // 안전관리자 아이디 조회 (해당 사업장 안)
      let managerIdList = await Commons.Axios(
        'post',
        Global.base.useUrl + Global.urls.Execute.execute,
        [
          {
            procedureName: 'SP_Get_MANAGER_INFO',
            _CUST_CD: Commons.EncryptAES(userInfo.custCd),
          },
        ]
      );
      // 안전관리자들에게 알람
      managerIdList.data.forEach(async (_item) => {
        await sendFcm({
          targetUserId: _item.CM_ID,
          requestUserId: userInfo.userid,
          body: '작업 허가서 요청입니다.',
          status: '요청',
          codeGroup: 'AL_002_001',
          title: '작업허가서',
          route: '/M_Permit',
          responseData: rowData1.PM_CD,
        });
      });
    }
    //신청인에게 알림
    else {
      await sendFcm({
        targetUserId: rowData1.USER_ID,
        requestUserId: userInfo.userid,
        body: '작업허가서 승인이 완료되었습니다.',
        status: '최종승인',
        codeGroup: 'AL_002_003',
        title: '작업허가서',
        route: '/M_Permit',
        responseData: rowData1.PM_CD,
      });
    }
  };

  const SearchLogic1 = async () => {
    setLoading(true);

    try {
      await Commons.Axios(
        'post1',
        Global.base.useUrl + Global.urls.Execute.execute,
        [
          {
            procedureName: 'SP_PERMIT_R2',
            _PM_CD: Commons.EncryptAES(id),
            _USER_ID: userInfo.userid,
            _AUTH_CD: Commons.EncryptAES(userInfo.authCd) || '',
          },
        ]
      ).then((result) => {
        let data = result.data;

        if (data.length === 0) {
          setRowData1(null);
          setRowData2([]);

          dispatch(
            showSnackbar({ message: '데이터가 없습니다.', type: 'info' })
          );
        } else if (data[0]?.type === 'Error') {
          dispatch(showSnackbar({ message: data[0].message, type: 'error' }));
          return false;
        } else {
          setRowData1(data[0]);
          const checklist = data.reduce((acc, item) => {
            if (!acc[item.WORK_TYPE_NM]) {
              acc[item.WORK_TYPE_NM] = [];
            }
            acc[item.WORK_TYPE_NM].push({
              WORK_TYPE_DTL: item.WORK_TYPE_DTL,
              WORK_TYPE_DTL_NM: item.WORK_TYPE_DTL_NM,
              ITEM_CHECK: item.ITEM_CHECK,
            });
            return acc;
          }, {});

          setRowData2(checklist);
        }
      });
    } catch (e) {
      console.log(e);
      dispatch(showSnackbar({ message: e.message, type: 'error' }));
    } finally {
      setLoading(false);
    }
  };

  const SaveLogic1 = async (gubun, returnDetail, signFile) => {
    try {
      let filePath = '';
      dispatch(BaseInfoActions.setFcmReceptionPayload('')); // fcmReceptionPayload 초기화
      if (gubun !== '0' && signFile) {
        filePath = await SaveLogic2(signFile);

        if (!filePath) return;
      }

      // 신청인에게 반려 알림
      if (gubun === '0') {
        await sendFcm({
          targetUserId: rowData1.USER_ID,
          requestUserId: userInfo.userid,
          body: '작업허가서 반려 안내',
          status: '반려',
          codeGroup: 'AL_002_002', // 작업허가서 알림 코드 그룹
          title: '작업허가서',
          route: '/M_Permit',
          responseData: rowData1.PM_CD,
        });
      }

      await Commons.Axios(
        'post',
        Global.base.useUrl + Global.urls.Execute.execute,
        [
          {
            procedureName: 'SP_PERMIT_U3',
            _PM_CD: Commons.EncryptAES(rowData1.PM_CD),
            _GUBUN: Commons.EncryptAES(gubun),
            _RETURN_DETAIL: Commons.EncryptAES(
              gubun === '0' ? returnDetail : ''
            ),
            _DEP_SIGN_PATH: gubun === '1' ? Commons.EncryptAES(filePath) : '',
            _SM_SIGN_PATH: gubun === '2' ? Commons.EncryptAES(filePath) : '',
            _DEP_HEAD_ID: Commons.EncryptAES(rowData1.DEP_HEAD_ID),
            _USER_ID: userInfo.userid,
          },
        ]
      );

      setIsComplete(true);
      SearchLogic1();
    } catch (error) {
      console.error(error);
      dispatch(
        showSnackbar({ message: '잠시 후 다시 실행해주세요.', type: 'error' })
      );
    }
  };

  const SaveLogic2 = async (signFile) => {
    try {
      let formList = new FormData();
      // 수정 필요
      let filePath = `Business/${
        rowData1.CUST_CD
      }/SAF_BASIC_02/${Commons.DecryptoAES(userInfo.userid)}`;

      formList.append('UserId', userInfo.userid);
      formList.append('FilePath', filePath);
      formList.append('FormFile', signFile);

      const result = await Commons.Axios(
        'file',
        Global.file.useUrl + Global.urls.Execute.videoUpload,
        null,
        formList
      );

      const data = result.data;

      if (data?.filePath) {
        return `${filePath}/${signFile.name}`;
      } else {
        dispatch(
          showSnackbar({ message: '잠시 후 다시 실행해주세요.', type: 'error' })
        );
        return null;
      }
    } catch (error) {
      dispatch(
        showSnackbar({ message: '잠시 후 다시 실행해주세요.', type: 'error' })
      );
      return null;
    }
  };

  const ConvertImageToBase64 = async (url) => {
    try {
      const response = await fetch(url);
      if (!response.ok) return '';
      const blob = await response.blob();
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => {
          resolve(reader.result);
        };
        reader.onerror = reject;
        reader.readAsDataURL(blob);
      });
    } catch (error) {
      console.error('이미지 변환 오류:', error);
      return '';
    }
  };

  const DeleteLogic1 = async () => {
    try {
      await Commons.Axios(
        'post',
        Global.base.useUrl + Global.urls.Execute.execute,
        [
          {
            procedureName: 'SP_PERMIT_D1',
            _PM_CD: Commons.EncryptAES(rowData1.PM_CD),
          },
        ]
      );

      await Commons.Axios(
        'post',
        Global.base.useUrl + Global.urls.Execute.execute,
        [
          {
            procedureName: 'SP_PERMIT_D2',
            _PM_CD: Commons.EncryptAES(rowData1.PM_CD),
          },
        ]
      );

      dispatch(
        showSnackbar({
          message: '작업허가서가 삭제되었습니다.',
          type: 'success',
        })
      );

      navigate('/M_Permit');
    } catch (error) {
      console.error(error);
      dispatch(
        showSnackbar({
          message: '삭제 중 오류가 발생했습니다.',
          type: 'error',
        })
      );
    }
  };

  return (
    <div className="wrap">
      <M_PER_BASIC_02
        rowData1={rowData1}
        rowData2={rowData2}
        loading={loading}
        userInfo={userInfo}
        activeStep={activeStep}
        setActiveStep={(step) => dispatch(CommonActions.setActiveStep(step))}
        // UI 상태/컨텍스트 전달
        activeIndex={activeIndex}
        setActiveIndex={setActiveIndex}
        isBaseChecked={isBaseChecked}
        setIsBaseChecked={setIsBaseChecked}
        isChecklistChecked={isChecklistChecked}
        setIsChecklistChecked={setIsChecklistChecked}
        isComplete={isComplete}
        setIsComplete={setIsComplete}
        mode={mode}
        setMode={setMode}
        ToggleDrawer={ToggleDrawer}
        // 함수
        signatureCanvas={signatureCanvas}
        SaveLogic1={SaveLogic1}
        handleSignRequest={handleSignRequest}
        ConvertImageToBase64={ConvertImageToBase64}
        DeleteLogic1={DeleteLogic1}
      />
    </div>
  );
}
